export const getStaticFile = (path?: string) => {
  if (!path) return;
  return path;
};

export const getFileExtension = (path?: string) => {
  if (!path) return '';
  return '.' + path.split('.').pop()?.toLowerCase() || '';
};